import { useEffect } from "react";

import { useStore } from "@nanostores/react";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { $allByFundId } from "./allByFundId.store";
import { $previousContextKey, contextKeyActions } from "./contextKey.store";
import { $selectedInvestorId } from "./investors.store";
import { $organizationId } from "./organisations.store";

type CustomHeadersReturnType = {
  limitedPartnerId: string | undefined;
  impersonatedUserId: string | undefined;
  fundId: string | undefined;
  contextParams: {
    limitedPartnerId: string | undefined;
    impersonatedUserId: string | undefined;
    fundId: string | undefined;
  };
  hasContextParams: boolean;
  contextKey: string;
  previousContextKey: string | undefined;
  resetPreviousContextKey: () => void;
};

export const useGetCustomHeaders = (): CustomHeadersReturnType => {
  const limitedPartnerId = useStore($organizationId);
  const selectedUserId = useStore($selectedInvestorId);
  const fundId = useStore($allByFundId);
  const previousContextKey = useStore($previousContextKey);

  const hasContextParams =
    isTruthy(limitedPartnerId) || isTruthy(selectedUserId) || isTruthy(fundId);

  const contextParams = {
    limitedPartnerId,
    impersonatedUserId: selectedUserId ?? "",
    fundId: fundId ?? "",
  };

  const computedContextKey = [limitedPartnerId, selectedUserId, fundId]
    .filter((v) => v !== undefined)
    .join("-");

  useEffect(() => {
    contextKeyActions.setContextKey(computedContextKey);
  }, [computedContextKey]);

  return {
    ...contextParams,
    contextParams: contextParams,
    hasContextParams: hasContextParams,
    contextKey: computedContextKey,
    previousContextKey,
    resetPreviousContextKey: contextKeyActions.resetPreviousContextKey,
  };
};
